import {hrmsWithPath} from "../../services/http/api/rest";
import type {AssetAllocationSearch} from "../../domains/models/asset-management/asset-allocation";

const rest = hrmsWithPath('/v1/assets');
const assetAllocation = hrmsWithPath('/v1/asset-allocation');
const assetCategory = hrmsWithPath('/v1/asset-categories');
const assetRequest = hrmsWithPath('/v1/asset-allocation/request');

const asset = {
    list: (id: string) => rest.get('/{{id}}', {id}, {}),
    search: (pageNumber?: any, pageSize?: any, data?: any) => rest.post('/search', {}, data, {
        "page-number": pageNumber,
        "page-size": pageSize
    }),
    create: (data: any) => rest.post('', {}, data),
    update: (id: any, data: any) => rest.put('/{{id}}', {id}, data),
    statusUpdate: (id: string, status: string) => rest.put('/{{id}}/update-status', {id}, {}, {"status": status}),
    return: (id: string, status: string) => rest.put('/{{id}}/return', {id}, {}, {"asset-status": status}),
    missing: (id: string) => rest.put('/{{id}}/missing', {id}),
    renewal: (id: string, date: any) => rest.put('/{{id}}/renew', {id}, {}, {"updated-return-date": date}),
    // Fetch summary of assets including counts by category and status.
    analysis: (sd: string, ed: string) => rest.get('/analysis', {}, {startDate: sd, endDate: ed}),
    allocate: (id: string, data: any) => assetAllocation.put('/{{id}}/allocate', {id}, data),

    allocation: {
        search: (pageNumber?: number, pageSize?: number, data?: AssetAllocationSearch) => assetAllocation.post('/search', {}, data, {
            "page-number": pageNumber,
            "page-size": pageSize
        }),
        create: (employeeId?: string, data?: any) => assetAllocation.post('/employee/{{employeeId}}/assign', {employeeId}, data),
    },

    category: {
        list: () => assetCategory.get('', {}, {}),
        create: (data: any) => assetCategory.post('', {}, data),
        update: (id: any, data: any) => assetCategory.put('/{{id}}', {id}, data),
    },
    request: {
        create: (id?: string, data?: any) => assetRequest.post('', {}, data, {"asset-category-id": id}, {"Content-Type": "text/plain"}),
        cancel: (id: string) => assetAllocation.put('/{{id}}/cancel', {id}),
        reject: (id: string, data: string) => assetAllocation.put('/{{id}}/reject', {id}, data, {}, {"Content-Type": "text/plain"}),
        approve: (id: any) => assetAllocation.put(`/{{id}}/approve`, {id}),
    },
}

export default asset;